module.exports = __webpack_public_path__ + "img/38.a19d29e1.jpg";